import {
  Box,
  HStack,
  VStack,
  Text,
  Container,
  Image,
  Button,
  SimpleGrid,
  Link as LinkChakra,
} from '@chakra-ui/react';
import React from 'react';
import Navbar from '../components/navbar';
import LOGO from '../img/logo/LOGO.png';
import { Link, Route } from 'react-router-dom';
import Books from '../components/Books';
import Books2 from '../components/Books2';
import Books3 from '../components/Books3';
import Books4 from '../components/Books4';
import Books5 from '../components/Books5';
import Books6 from '../components/Books6';
import Books7 from '../components/Books7';
import Books8 from '../components/Books8';
import Books9 from '../components/Books9';
import Books10 from '../components/Books10';
import Books11 from '../components/Books11';
import Books12 from '../components/Books12';
import Books13 from '../components/Books13';
import Books14 from '../components/Books14';
import Books15 from '../components/Books15';
import Books16 from '../components/Books16';
import Books17 from '../components/Books17';
import Books18 from '../components/Books18';
import Books19 from '../components/Books19';
import Books20 from '../components/Books20';
import Books21 from '../components/Books21';
import Books22 from '../components/Books22';
import Books23 from '../components/Books23';

import MainLogo from '../components/MainLogo';
import p1 from '../img/patrens/patren1.png';
import p2 from '../img/patrens/patren2.png';
import p3 from '../img/patrens/patren3.png';
import p4 from '../img/patrens/patren4.png';
import p5 from '../img/patrens/patren5.png';
import p6 from '../img/patrens/patren6.png';
import Header from '../components/Header';

const start = () => {
  return (
    <>


      <Box m={0} p={0}>
        <HStack spacing="24px" justifyContent={'center'} mt={'10px'}>
          <Box w={['200px !important','400px']} h={'50%'} textAlign={'center'}>
            <Image src={LOGO} alt="LOGO" />
          </Box>
        </HStack>
        <Header />

     

        {/* =========BOOKS=========== */}
        <Books />
        
        <Books2 />
        <Books3 />
        <Books4 />
        <Books5 />
        <Books6 />
        <Books7 />
        <Books8 />
        <Books9 />
        <Books10 />
        <Books11 />
        <Books12 />
        <Books13 />
        <Books14 />
        <Books15 />
        <Books16 />
        <Books17 />
        <Books18 />
        <Books19 />
        <Books20 />
        <Books21 />
        <Books22 />
        <Books23 />

        {/* BTN
        <Box>
          <HStack spacing="50px" justifyContent={'center'}>
            <LinkChakra href="https://lpt.moc.gov.sa/ar/TarjimLibrary">
              <Text
                textAlign={'center'}
                w="630px"
                h="70px"
                mt={5}
                mb={7}
                color={'#fff'}
                bg={'#0F2837'}
                fontSize={'40px'}
                borderRadius={'10px'}
              >
                تصفح المزيد
              </Text>
            </LinkChakra>
          </HStack>
        </Box> */}
      </Box>
    </>
  );
};

export default start;
